"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransformRuleSetBase = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _map = _interopRequireDefault(require("lodash/map"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _services = require("../services");

var _constants = _interopRequireDefault(require("../constants"));

var _commonUtils = require("../commonUtils");

var TransformRuleSetBase =
/*#__PURE__*/
function () {
  function TransformRuleSetBase() {
    (0, _classCallCheck2["default"])(this, TransformRuleSetBase);
  }

  (0, _createClass2["default"])(TransformRuleSetBase, null, [{
    key: "getNonProductAttributes",
    value: function getNonProductAttributes(requiredAttributes) {
      return (0, _filter["default"])(requiredAttributes, function (input) {
        return input.scope === _constants["default"].DESTINATION || input.scope === _constants["default"].ORDER;
      });
    }
  }, {
    key: "convertAttributesInWhiteList",
    value: function convertAttributesInWhiteList(attributesToAdd) {
      return (0, _map["default"])(attributesToAdd, function (attribute) {
        var modifiedAttribute = {
          required: !attribute.empty,
          derived: false,
          type: (0, _commonUtils.areKeysSame)(attribute.type, _constants["default"].VALUES) ? _constants["default"].LISTOFVALUES : _constants["default"].LISTOFRANGES,
          "class": attribute.scope,
          attributeKey: attribute.name
        };

        if ((0, _commonUtils.areKeysSame)(attribute.type, _constants["default"].VALUES)) {
          modifiedAttribute.attributeValues = TransformRuleSetBase.getAttributeValues(attribute);
        } else {
          modifiedAttribute.attributeRanges = TransformRuleSetBase.getAttributeRanges(attribute);
        }

        return modifiedAttribute;
      });
    }
  }, {
    key: "getAttributeValues",
    value: function getAttributeValues(nonProductAttribute) {
      return (0, _commonUtils.areKeysSame)(nonProductAttribute.name, _constants["default"].COUNTRY) && (0, _commonUtils.areKeysSame)(nonProductAttribute.scope, _constants["default"].DESTINATION) ? (0, _services.transformInputs)(nonProductAttribute.inputValues) : nonProductAttribute.inputValues;
    }
  }, {
    key: "getAttributeRanges",
    value: function getAttributeRanges(nonProductAttribute) {
      var attributeRanges = [];

      if ((0, _commonUtils.areKeysSame)(nonProductAttribute.type, _constants["default"].ANY) || (0, _commonUtils.areKeysSame)(nonProductAttribute.type, _constants["default"].RANGES)) {
        attributeRanges = (0, _isEmpty["default"])(nonProductAttribute.inputRanges) ? [{
          minimum: 0
        }] : nonProductAttribute.inputRanges;
      }

      return attributeRanges;
    }
  }]);
  return TransformRuleSetBase;
}();

exports.TransformRuleSetBase = TransformRuleSetBase;